import { TextField } from "@mittwald/flow-components/dist/components/TextField";
import type { FC } from "react";
import React from "react";

export const NewPasswordTextField: FC = () => {
  return (
    <TextField
      autoComplete="new-password"
      label="password"
      name="password"
      rules={{ required: true, minLength: 12 }}
      type="passwordWithGenerator"
    />
  );
};
